import {
  KSendSuccessResponse,
  NavigationCustomizationDataDtoResponse,
  NavigationCustomizationItemDto,
  NavigationCustomizationItemDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';
import {
  MutationFunction,
  QueryFunction,
  QueryKey,
} from '@tanstack/react-query';

import { QueryKeyWithRole } from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export const fetchNavigationCustomization: QueryFunction<
  NavigationCustomizationDataDtoResponse | null,
  QueryKeyWithRole<QueryKey>
> = async () => {
  const result =
    await portalGatewayClient.navigation.getNavigationCustomizations();

  return result.data;
};

export const createNavigationCustomization: MutationFunction<
  NavigationCustomizationItemDtoResponse,
  { data: NavigationCustomizationItemDto }
> = async ({ data }) => {
  const response =
    await portalGatewayClient.navigation.postNavigationCustomization(data);

  return response.data;
};

export const deleteNavigationCustomization: MutationFunction<
  KSendSuccessResponse,
  { itemId: string }
> = async ({ itemId }) => {
  const response =
    await portalGatewayClient.navigation.deleteNavigationCustomization(itemId);

  return response.data;
};

export const deleteAllNavigationCustomization = async () => {
  const response =
    await portalGatewayClient.navigation.deleteAllNavigationCustomization();

  return response.data;
};

export const updateNavigationCustomization: MutationFunction<
  KSendSuccessResponse,
  { data: NavigationCustomizationItemDto }
> = async ({ data }) => {
  const response =
    await portalGatewayClient.navigation.updateNavigationCustomization(data);

  return response.data;
};
